import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"
import {User} from "types/User"

interface ReturnedType {
    status: "success"
    user: User
}

interface DataProps {
    id: number
    data: {
        full_name: string
        email: string
        password?: string
    }
}

export const editStaffUser = createAsyncThunk<ReturnedType, DataProps, AppThunkProps>(
    "staff/edit",
    async ({id, data}, {signal}) => {
        return api.patch<ReturnedType>(`/user/${id}`, data, {signal})
    }
)
